import * as React from 'react';
import { observer } from 'mobx-react';
import { JSSClassesProps } from 'react-jss';
import { ComponentJSSClasses } from './styles';
import { TagCheckbox } from '../TagCheckbox';
import { Tag } from '../../../../../models/hotel-reviews';
import S from '../../../../../stores';

export interface InterestsFilterMobileProps {
    tags: Tag[];
}

interface StyledInterestsFilterMobileProps
    extends JSSClassesProps<ComponentJSSClasses>,
        InterestsFilterMobileProps {}

const VISIBLE_TAGS = 10;

export const InterestsFilterMobile = observer((props: StyledInterestsFilterMobileProps) => {
    const { classes, tags } = props;

    const isChecked = (interest: number): boolean =>
        S.hotelReviews.interestsFilter.includes(interest);

    const handleChange = (interest: number) => {
        S.hotelReviews.setInterestsFilter(interest);
    };

    return (
        <div className={classes.block}>
            <h3 className={classes.title}>Интересное в отзывах</h3>
            <div className={classes.container}>
                {tags.slice(0, VISIBLE_TAGS).map((tag: Tag) => (
                    <TagCheckbox
                        inputName={tag.displayName}
                        label={tag.id}
                        checked={isChecked(tag.id)}
                        onChange={handleChange}
                        key={tag.id}
                    />
                ))}
            </div>
        </div>
    );
});
